module.exports = __webpack_public_path__ + "img/program-6plus-19-07-2023.a7ba9255.png";